import { render, staticRenderFns } from "./employeesabsenteeism.vue?vue&type=template&id=6e0af0a0&"
import script from "./employeesabsenteeism.vue?vue&type=script&lang=js&"
export * from "./employeesabsenteeism.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports